<template name="filtering">
  <transition>
    <div
      class="
        flex
        md:flex-row
        flex-col
        items-start
        justify-start
        px-6
        py-0
        w-full
        z-50
        absolute
        mt-12
        lg:ml-20
      "
    >
      <div
        id="popover"
        class="
          transition
          duration-150
          ease-in-out
          md:mt-0
          mt-0
          top-0
          left-0
          sm:ml-10
          md:ml-10
          w-11/12
          lg:w-6/12
          z-50
        "
      >
        <div class="w-full bg-white border rounded-lg shadow-2xl">
          <div class="relative bg-gray-200 rounded-t py-3 px-4">
            <div class="flex justify-between">
              <button
                class="
                  focus:underline focus:text-gray-600
                  hover:text-gray-600
                  focus:outline-none
                  text-gray-800
                  cursor-pointer
                  md:block
                "
                @click="$emit('close')"
              >
                <i class="fas fa-times close-icon text-lg" title="Close"></i>
              </button>

              <button
                class="
                  focus:text-gray-600
                  hover:text-gray-600
                  focus:outline-none
                  text-gray-800
                  cursor-pointer
                  md:block
                  pr-2
                  text-xs
                "
                @click="resetFilter()"
              >
                <i class="fas fa-redo pr-1 txt-xs" title="Clear"></i> Clear
                filter
              </button>
            </div>

            <i
              class="
                fas
                fa-caret-up
                hidden
                md:block
                absolute
                top-0
                -mt-6
                mr-56
                right-0
                bottom-0
                text-5xl text-gray-200
              "
            ></i>
          </div>
          <div class="w-full h-full pl-4 pr-3">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <div class="form-box border-gray-50 border-opacity-25">
                  <div class="form-box-title">Class / Group</div>
                  <p class="bg-white">

                    <ClassDropdown :classSelected="selectedClass" @classValueChanged="classSelect"
                    v-bind:class="
                        selectedClass.id > 0
                          ? 'filter-item-button-on text-gray-900'
                          : 'filter-item-button-off'
                      "></ClassDropdown>
                  </p>
                </div>

                <div class="form-box border-0">
                  <div class="form-box-title">Year Groups</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in yearDropdown"
                      :key="item.key_value"
                      class="inline-block mr-2"
                    >
                      <button
                        type="button"
                        @click="filterYearValue(item.key_value)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inYearFilter(item.key_value)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inYearFilter(item.key_value)
                              ? 'fa-check-square'
                              : 'fa-square'
                          "
                        ></i>
                        Y{{ item.letter }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div v-if="1 == 3" class="form-box">
                  <div class="w-full">
                    <h2 class="form-box-title">Unit / Course</h2>
                    <p>
                      <dropdown
                        :options="courseDropdown"
                        :selected="filteredCourse"
                        v-on:updateOption="courseSelect"
                        v-bind:class="
                          filteredCourse.id > 0
                            ? 'text-green-500 font-bold'
                            : 'text-gray-500'
                        "
                      >
                        ></dropdown
                      >
                    </p>
                  </div>
                </div>
              </div>

              <div class="border-l border-gray-50 pl-5">
                <div class="form-box border-gray-50 border-opacity-25">

           
                  <div class="form-box-title flex justify-between w-full">Search Tags
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500 tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                    </div>
                    
                  </div>
                  <div class="relative">
                    <div
                      class="
                        flex
                        absolute
                        inset-y-0
                        left-0
                        items-center
                        pl-3
                        pointer-events-none
                      "
                    >
                      <svg
                        class="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="search"
                      class="
                        h-full
                        text-gray-700
                        placeholder-gray-500
                        w-11/12
                        bg-gray-100
                        rounded
                        shadow-sm
                        p-2
                        pl-10
                        mr-3
                        mt-1
                      "
                      name="search"
                      v-model="search"
                      placeholder="Enter tags to search..."
                    />
                  </div>
                  <div class="mt-4 text-center"> 

  <ul class="mb-1 w-full">
    <li
                     
                     class="mr-2 inline-block"
                   >
                     <button
                       type="button"
                       @click="includePupils = false"
                       class="filter-item-button hover:bg-opacity-50 wide"
                       v-bind:class="
                        !includePupils
                           ? 'filter-item-button-on'
                           : 'filter-item-button-off'
                       "
                     >
                       <i
                         class="far pr-1"
                         v-bind:class="
                           !includePupils ? 'fa-check-circle' : 'fa-circle'
                         "
                       ></i>
                      Evidence Tags
                     </button>
                   </li>

                    <li
                     
                      class="mr-2 inline-block"
                    >
                      <button
                        type="button"
                        @click="includePupils = true"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                         includePupils
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            includePupils ? 'fa-check-circle' : 'fa-circle'
                          "
                        ></i>
                       Pupil Tags
                      </button>
                    </li>
                  </ul>

                  </div>
                </div>

                <div class="form-box no-border">
                  <div class="form-box-title">Dates</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in dateFilterList"
                      :key="item.key"
                      class="mr-2 inline-block"
                    >
                      <button
                        type="button"
                        @click="updateDateFilter(item)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inDateFilter(item)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inDateFilter(item) ? 'fa-check-circle' : 'fa-circle'
                          "
                        ></i>
                        {{ item.title }}
                      </button>
                    </li>
                  </ul>

                  <div
                    class="flex flex-wrap mr-1 mt-3"
                    v-if="selectSpecificRange"
                  >
                    <div class="w-full md:w-1/2 pr-1 mb-6 md:mb-0">
                      <label class="form-label" for="grid-title">
                        From date</label
                      >
                      <datetime
                        v-model="startDate"
                        input-class="date-input"
                        :format="{
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }"
                        :auto="true"
                      ></datetime>
                    </div>

                    <div class="w-full md:w-1/2 pl-1">
                      <label class="form-label" for="grid-title">
                        To date</label
                      >
                      <datetime
                        v-model="endDate"
                        input-class="date-input"
                        :format="{
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }"
                        :auto="true"
                      ></datetime>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="
              w-full
              text-center
              bg-gray-200
              pt-5
              rounded-br-lg rounded-bl-lg
            "
          >
            <button
              @click="filterButtonPressed()"
              class="
                mx-auto
                w-1/3
                mb-4
                focus:ring-2 focus:ring-offset-2
                rounded-md
                focus:ring-indigo-600
                transition
                duration-150
                ease-in-out
                hover:bg-indigo-600
                focus:outline-none
                bg-indigo-700
                rounded-r
                text-white
                px-3
                py-1
                text-sm
              "
            >
              Apply filter
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";
import { Datetime } from "vue-datetime";

const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");

import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";
import { EvidenceFilter } from "@/services/evidence.service";

const DateList = [
  {
    key: "today",
    title: "Last 24 hours",
    since: moment().subtract(1, "days"),
    until: moment().endOf("day"),
  },
  {
    key: "week",
    title: "Last week",
    since: moment().subtract(1, "weeks"),
    until: moment().add(5),
  },
  {
    key: "month",
    title: "Last month",
    since: moment().subtract(1, "months"),
    until: moment().endOf("day"),
  },
  {
    key: "specific",
    title: "Date range",
    since: moment().subtract(1, "months"),
    until: moment().endOf("day"),
  },
];

export default {
  name: "filtering",
  mixins: [yearGroupMixin],
  props: {
    calendar: {type: Object, required: true },
    values: { type: Object, required: false },
  },
  computed: {
    yearDropdown() {
      return this.years;
    },
    courseDropdown() {
      var vm = this;

      // let distinct = new Set(vm.evidences.map((e) => e.course.name))
      // var units = Array.from(distinct).map(function(item, index) {
      //   return {"id": index + 1, "name": item}
      // })

      // var results = [{ id: 0, name: "Select a Unit" }].concat(units);

      // this.filteredCourse = results[0];
      // return results;
    },
    selectSpecificRange() {
      return this.selectedDate.key === "specific";
    },
  },
  data() {
    return {
      dateFilterList: DateList,
      filteredYears: [],
      selectedClass: {},
      filteredCourse: {},
      search: "",
      includePupils: false,
      selectedDate: {},
      startDate: moment().subtract(6, "weeks").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  },
  watch: {
    // '$props':{
    //   handler: function (val, oldVal) { 
    //     console.log(this.calendar.value, JSON.stringify(val))
    //   },
    //   deep: true
    // }
  },
  created() {
  },
  mounted() {
    // set preset values if exist
    if (!!Object.keys(this.values).length) {
      if (this.values.years != undefined) {
        this.filteredYears = this.values.years;
      }

      if (this.values.group != undefined) {
        this.classSelect(this.values.group);
      }

      if (this.values.date != undefined) {
        this.selectedDate = this.values.date;
      }

      if (this.values.includePupilTags != undefined) {
        this.includePupils = this.values.includePupilTags
      }

      this.search = this.values.tags
    }
  },
  methods: {
    updateDateFilter(dt) {
      if (dt.key === this.selectedDate.key) {
        this.selectedDate = {};
      } else {
        this.selectedDate = dt;
      }
    },
    inDateFilter(dt) {
      return this.selectedDate.key === dt.key;
    },
    classSelect(value) {
      if (this.selectedClass === undefined) {
        this.selectedClass = {};
      } else {
        this.selectedClass = value;
      }
    },
    courseSelect(value) {
      this.filteredCourse = value;
    },
    filterYearValue(value) {
      if (this.filteredYears.includes(value)) {
        this.filteredYears.splice(this.filteredYears.indexOf(value), 1);
      } else {
        this.filteredYears.push(value);
      }
      this.$emit("yearsUpdated", this.filteredYears);
    },
    inYearFilter(value) {
      return this.filteredYears.includes(value);
    },
    resetFilter() {
      this.filteredYears = [];
      this.filteredCourse = {};
      this.selectedDate = {};
      this.search = ""
      this.selectedClass = {};
    },
    addTags(value) {
      let seperator = this.search.length > 0 ? " #" : "#"
      this.search = this.search + seperator + value
    },
    filterButtonPressed() {
      if (this.selectSpecificRange) {
        this.selectedDate.since = this.startDate;
        this.selectedDate.until = this.endDate;
      }

      let payloadYears =
        this.filteredYears.length > 0 ? this.filteredYears : undefined;
      let payloadClass =
        this.selectedClass.id > 0 ? this.selectedClass : undefined;

      let payload = new EvidenceFilter(
        this.calendar,
        payloadYears,
        payloadClass,
        this.selectedDate,
        this.search,
        this.includePupils
      );
      this.$emit("apply-filter", payload);
    },
  },
  components: {
    ClassDropdown,
    datetime: Datetime,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>